
    // this file was auto generated by python script
    import FolderPlus from './FolderPlus';
    export default FolderPlus;
    